<h1 mat-dialog-title>Bijzonderheden beheren</h1>

<div mat-dialog-content class="dialog-no-overflow">
  <div class="warning">
    Let op! Het uitschakelen van een bijzonderheid zorgt er ook voor dat deze niet meer zichtbaar is bij ritten die al
    ingepland zijn.
  </div>
  <form [formGroup]="orgsForm" autocomplete="off">
    <mat-form-field>
      <mat-label>Organisatie</mat-label>
      <mat-select formControlName="org">
        @for (org of orgs(); track org.id) {
          <mat-option [value]="org">
            {{ org.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @for (particularity of globalParticularities(); track particularity.id) {
      <mat-slide-toggle [formControlName]="particularity.id">
        {{ particularity.name }}
      </mat-slide-toggle>
    }
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuleren</button>

  <button mat-flat-button [class.spinner]="saving()" [disabled]="!orgsForm.valid || saving()" (click)="save()">
    Opslaan
  </button>
</div>
